import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  constructor() {
    //Do nothing
  }

  ngOnInit(): void {
    window.scroll(0, 0);
  }
}
